var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as viem from 'viem';
import Multicall from '../contracts/abis/Multicall3_1.json';
import { PythAdapter } from './eip7412/PythAdapter';
import { ethers } from 'ethers';
import { BLAST_NETWORK_LOOKUP, DEFAULT_TESTNET_PYTH_SERVER_URL, PERPS_PYTH_IDS } from '../constants';
import { EIP7412 } from './eip7412/EIP7412';
const adapter = new PythAdapter(DEFAULT_TESTNET_PYTH_SERVER_URL);
export function generate7412CompatibleCall(client, multicallFunc, txn) {
    return __awaiter(this, void 0, void 0, function* () {
        const adapters = [adapter];
        const converter = new EIP7412(adapters, multicallFunc);
        // TODO: Should pass dynamically specified based on the call requirements
        const predefinedOracles = [
            PERPS_PYTH_IDS.sETH.testnet,
            PERPS_PYTH_IDS.sBTC.testnet,
            PERPS_PYTH_IDS.LINK.testnet,
            PERPS_PYTH_IDS.OP.testnet,
            PERPS_PYTH_IDS.SNX.testnet,
        ];
        const clientPrepared = yield converter.enableERC7412(client, txn, predefinedOracles);
        return clientPrepared;
    });
}
export default class CallsService {
    constructor(sdk) {
        this.vmClients = {};
        this.sdk = sdk;
    }
    get viemClients() {
        if (this.vmClients[this.sdk.context.networkId])
            return this.vmClients[this.sdk.context.networkId];
        const networkSlug = BLAST_NETWORK_LOOKUP[this.sdk.context.networkId];
        // Using the Kwenta apps context provider (FallbackProvider) currently doesn't work within the viem client
        const provider = networkSlug
            ? new ethers.providers.StaticJsonRpcProvider(`https://${networkSlug}.blastapi.io/${process.env.NEXT_PUBLIC_BLASTAPI_PROJECT_ID}/`)
            : new ethers.providers.InfuraProvider(this.sdk.context.networkId);
        const clients = {
            write: viem.createPublicClient({
                transport: viem.custom({
                    request: ({ method, params }) => {
                        params[0].from = this.sdk.context.walletAddress;
                        return provider.send(method, params);
                    },
                }),
            }),
            read: viem.createPublicClient({
                transport: viem.custom({
                    request: ({ method, params }) => {
                        return provider.send(method, params);
                    },
                }),
            }),
        };
        this.vmClients[this.sdk.context.networkId] = clients;
        return clients;
    }
    erc7412(tx, multicallFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            const txn = yield generate7412CompatibleCall(this.viemClients.read, multicallFunc, tx);
            const result = yield this.viemClients.read.call({
                account: '0x4200000000000000000000000000000000000006',
                data: txn.data,
                to: txn.to,
                value: txn.value,
            });
            const decodedFunctionResult = viem.decodeFunctionResult({
                abi: Multicall.abi,
                functionName: 'aggregate3Value',
                data: result.data,
            });
            const last = viem.decodeFunctionResult({
                abi: Multicall.abi,
                functionName: 'aggregate3Value',
                data: decodedFunctionResult[decodedFunctionResult.length - 1].returnData,
            });
            return last;
        });
    }
    erc7412Write(tx, multicallFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            const txn = yield generate7412CompatibleCall(this.viemClients.write, multicallFunc, tx);
            txn.from = this.sdk.context.walletAddress;
            delete txn.account;
            return this.sdk.transactions.createEVMTxn(txn);
        });
    }
}
